// extracted by mini-css-extract-plugin
module.exports = {"root":"modal_root__ZCJlN","modal":"modal_modal__nfdO9","scrollContainer":"modal_scrollContainer__Vlwrm","close":"modal_close__FoKph"};